import { PAGE_NAMES } from '../../core/helpers/constants';
import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'MENU',
    //     isTitle: true
    // },
    // {
    //     id: 3,
    //     label: 'EMAIL',
    //     icon: 'mail',
    //     link: '/pages/emails',
    //     pageName: PAGE_NAMES.Emails
    // },
    // {
    //     id: 17,
    //     label: 'SETTINGS',
    //     icon: 'settings',
    //     link: '',
    //     pageName: PAGE_NAMES.Settings
    // },
    {
        id: 1,
        label: 'HOME',
        icon: 'home',
        link: '/pages/dashboard',
        pageName: PAGE_NAMES.Dashboard
    },
    {
        id: 2,
        label: 'TASKS',
        icon: 'list',
        link: '/pages/tasks',
        pageName: PAGE_NAMES.Tasks
    },
    {
        id: 4,
        label: 'CAMPAIGNS',
        icon: 'globe',
        link: '/pages/campaigns',
        pageName: PAGE_NAMES.Campaigns
    },
    {
        id: 5,
        label: 'REPORTS',
        icon: 'layout',
        link: '/pages/reports',
        pageName: PAGE_NAMES.Reports
    },
    {
        id: 6,
        label: 'LEADS',
        icon: 'bar-chart-2',
        link: '/pages/leads',
        pageName: PAGE_NAMES.Leads
    },
    {
        id: 7,
        label: 'COMPANIES',
        icon: 'briefcase',
        link: '/pages/companies',
        pageName: PAGE_NAMES.Companies
    },
    {
        id: 8,
        label: 'CLIENTS',
        icon: 'user',
        link: '/pages/clients',
        pageName: PAGE_NAMES.Clients
    },
    {
        id: 9,
        label: 'PROSPECTS',
        icon: 'user-plus',
        pageName: PAGE_NAMES.Prospects,
        link: '/pages/prospects',
    },
    {
        id: 10,
        label: 'USERS',
        icon: 'server',
        link: '/pages/users',
        pageName: PAGE_NAMES.Users
    },
    {
        id: 11,
        label: 'SHOP',
        icon: 'shopping-bag',
        link: '/pages/shop',
        pageName: PAGE_NAMES.Shop
    },
    {
        id: 12,
        label: 'PRODUCTS',
        icon: 'package',
        link: '/pages/products',
        pageName: PAGE_NAMES.Products
    },
    {
        id: 13,
        label: 'COUPONS',
        icon: 'percent',
        link: '/pages/coupons',
        pageName: PAGE_NAMES.Coupons
    },
    {
        id: 14,
        label: 'SUBSCRIPTIONS',
        icon: 'refresh-cw',
        link: '/pages/subscriptions',
        pageName: PAGE_NAMES.Subscriptions
    },
    {
        id: 15,
        label: 'ORDERS',
        icon: 'dollar-sign',
        link: '/pages/orders',
        pageName: PAGE_NAMES.Orders
    },
    {
        id: 16,
        label: 'SEARCHES',
        icon: 'search',
        link: '/pages/searches',
        pageName: PAGE_NAMES.Searches
    },
    {
        id: 17,
        label: 'TAGS',
        icon: 'tag',
        link: '/pages/tags',
        pageName: PAGE_NAMES.Tags
    },
    {
        id: 18,
        label: 'FORMS',
        icon: 'book-open',
        name: 'forms',
        link: '/pages/forms',
        pageName: PAGE_NAMES.Forms
    },
    {
        id: 19,
        label: 'MY_ACCOUNT',
        icon: 'clipboard',
        link: '/pages/myaccount',
        pageName: PAGE_NAMES.MyAccount
    },
    {
        id: 20,
        label: 'AUTOMATIONS',
        icon: 'code',
        name: 'automations',
        link: '/automations',
        openOnNewPage: true,
        pageName: PAGE_NAMES.Automations
    },
    {
        id: 21,
        label: 'PARTNERS',
        icon: 'users',
        link: 'https://reach.marketing/partners/',
        openOnNewPage: true,
        pageName: 'Partners'
    },
    {
        id: 22,
        label: 'FAQ',
        icon: 'help-circle',
        link: 'https://reach.marketing/faq/',
        openOnNewPage: true,
        pageName: 'FAQ'
    },
    {
        id: 23,
        label: 'LOGOUT',
        icon: 'log-out',
        name: 'logout'
    },
];
